export default {
  props: {
    displayEmptyField: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.initializeValue();
    this.addEventOnBlur();
  },
  beforeDestroy() {
    this.removeBlurEvent();
  },
  computed: {
    selectedOptionTextField() {
      if (!this.selectedOptionObject) return '';
      const optionText = this.selectedOptionObject[this.textField];
      return optionText || this.selectedOptionObject;
    },
    nullOption() {
      const text = this.displayEmptyField ? ' ' : this.$t('general.select');
      return {
        [this.textField]: text,
        [this.valueField]: null,
      };
    },
  },
  methods: {
    removeBlurEvent() {
      const button = this.getDropdownButtonElement();
      if (!button) return;
      button.removeEventListener('blur', this.emitBlur);
    },
    emitBlur(event) {
      this.$emit('blur');
      event.preventDefault();
    },
    addEventOnBlur() {
      const button = this.getDropdownButtonElement();
      if (!button) return;
      button.addEventListener('blur', this.emitBlur);
    },
    selectItem(item, emitChange = true, emitInput = true) {
      this.selectedOptionObject = this.getValueObject(item) || this.nullOption;
      const valueToEmit = this.selectedOptionObject[this.valueField] !== undefined
        ? this.selectedOptionObject[this.valueField]
        : this.selectedOptionObject;
      if (emitInput) {
        this.$emit('input', valueToEmit);
      }
      if (emitChange) {
        this.$emit('change', valueToEmit);
      }
    },
    initializeValue() {
      if (this.value !== undefined) {
        this.selectItem(this.value, false, false);
        return;
      }

      if (this.skipInitializeValue) {
        return;
      }

      const options = this.options || [];
      this.selectItem(options[0], false, false);
    },
    comparePrimitiveValues(item, option) {
      const parsedItem = typeof item === 'number' ? item.toString() : item;
      const parsedOption = typeof option === 'number' ? option.toString() : option;
      return parsedOption === parsedItem;
    },
  },
  watch: {
    options() {
      this.initializeValue();
    },
    value() {
      this.selectedOptionObject = this.getValueObject(this.value);
    },
  },
};
